import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import InputField from "../../../common/CustomInputField";
import { Oval } from "react-loader-spinner";
import { getKeyFromText } from "../../../utils/Utilities";
import { addSubOwnerStyle as style } from "./helper";
import { ImportTabDocument } from "../../../services/yourAssets/CommonServices";
import { useParams } from "react-router-dom";
import { getUserIdFromLocalStorage } from "../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { handleReloadFiles } from "../../../redux/slices/yourAssets/AssetsDocumentsSlice";
import { useDispatch } from "react-redux";
import { Form, Formik } from "formik";
import * as Yup from "yup";
const AddOwner = ({ open, handleClose, sectionId }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  let uID = getUserIdFromLocalStorage();
  const [btnLoader, setBtnLoader] = useState(false);

  const handleSubmit = async (values, setErrors) => {
    let formData = new FormData();

    formData.append("BoaUserMediaFile", values.documentFile);
    formData.append("SectionType", sectionId);
    setBtnLoader(true);
    try {
      let result = await ImportTabDocument(formData, id ? id : uID);
      if (result?.success) {
        handleClose();
        dispatch(handleReloadFiles());
      } else {
        toast.error(t(getKeyFromText(result?.message).replace(".", "")));
      }
    } catch (e) {
      console.log(e);
    } finally {
      setBtnLoader(false);
    }
  };
  const FILE_SIZE = 25;
  const validate = Yup.object().shape({
    documentFile: Yup.mixed().test(
      "fileSize",
      t("file-size-should-be-less-than-25-mb"),
      (value) => value.size / 1048576 <= FILE_SIZE
    ),
  });

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          lg={12}
          sx={{
            backgroundColor: "color.magentaLight2",
            padding: "10px",
            color: "color.brown",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography id="modal-modal-title" pl={3} component="p">
            {t("upload")}
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              onClick={() => handleClose()}
              sx={{
                cursor: "pointer",
              }}
              pr={1}
              variant="h6"
              component="h2"
            >
              <img src="/assets/icons/close-icon.svg" alt="Close" />
            </Typography>
          </Box>
        </Box>
        <Formik
          initialValues={{ documentFile: "" }}
          validationSchema={validate}
          onSubmit={(values, { setErrors }) => {
            handleSubmit(values, setErrors);
          }}
        >
          {(formik) => {
            return (
              <>
                <Form>
                  <Box sx={{ width: "100%", padding: "20px" }}>
                    <InputField
                      label={t("input-18")}
                      onChange={(e) =>
                        formik.setFieldValue(
                          "documentFile",
                          e.currentTarget.files[0]
                        )
                      }
                      name="documentFile"
                      type="file"
                      docName={formik.values?.documentFile?.name}
                      error={formik.errors}
                    />
                  </Box>
                  <Box display="flex" justifyContent="center">
                    {btnLoader ? (
                      <Button
                        disabled
                        sx={{
                          color: "color.brown",
                          padding: "8px 50px",
                          backgroundColor: "color.magentaLight2",
                          margin: "4rem auto 1rem auto",
                          fontWeight: "bold",
                          borderRadius: "15px",
                          opacity: "0.6",
                        }}
                      >
                        <Oval
                          height="20"
                          width="20"
                          color="grey"
                          ariaLabel="loading"
                        />
                      </Button>
                    ) : (
                      <Button
                        sx={{
                          color: "color.brown",
                          padding: "8px 50px",
                          backgroundColor: "color.magentaLight2",
                          margin: "4rem auto 1rem auto",
                          fontWeight: "bold",
                          borderRadius: "15px",
                          textTransform: "initial",
                          "&:hover": {
                            backgroundColor: "color.magentaLight1",
                            boxShadow: "none",
                          },
                        }}
                        type="submit"
                      >
                        {t("save")}
                      </Button>
                    )}
                  </Box>
                </Form>
              </>
            );
          }}
        </Formik>
      </Box>
    </Modal>
  );
};

export default AddOwner;
